import { css } from '@emotion/css'

import { spacing } from '../../../styles'
import { colors } from '../../../themes'

const styles = {
  wrapper: css({
    flexDirection: 'column',
    width: '100%',
  }),

  toggle: css({
    boxSizing: 'border-box',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',

    '&:hover': {
      outline: 'none',
      textDecoration: 'underline',
      color: colors.grayChateau,
    },
  }),

  title: css({
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'pre',
    paddingRight: spacing.small,

    '& strong': {
      paddingLeft: spacing.small,
    },
  }),

  caret: css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),

  body: css({
    padding: `0 ${spacing.small}`,
  }),
}

export default styles
